import { memo, useMemo } from "react";

import { QuestionPlanRoomConnection as Question } from "@/components/features/items/edit/plan/_shared/ui/components/connection/room-connection";

import { usePlanAvailableRoomIDs } from "./hooks";

export const QuestionPlanDummyRoomConnection = memo(() => {
	const { availableItemIDs, rawAvailableItemIDs, nameAndIDOptions, onSetAvailableItemIDs, isShowRoomForGuest } =
		usePlanAvailableRoomIDs();

	const title = useMemo(
		() => (isShowRoomForGuest.value ? "予約可能な部屋" : "予約可能な部屋（１部屋）"),
		[isShowRoomForGuest],
	);
	const guide = useMemo(
		() =>
			isShowRoomForGuest.value
				? "この日帰りプランで予約可能な部屋を選びましょう。"
				: "この日帰りプランで予約可能な部屋を選びましょう。<br />日帰りプラン限定の、在庫管理用のダミーの部屋を１部屋だけ選択することで販売ができます。",
		[isShowRoomForGuest],
	);

	return (
		<Question
			title={title}
			guide={guide}
			availableItemIDs={availableItemIDs}
			rawAvailableItemIDs={rawAvailableItemIDs}
			nameAndIDOptions={nameAndIDOptions}
			onSetAvailableItemIDs={onSetAvailableItemIDs}
		/>
	);
});

QuestionPlanDummyRoomConnection.displayName = "QuestionPlanDummyRoomConnection";
